import { render, staticRenderFns } from "./indexshansong.vue?vue&type=template&id=af5072ee"
import script from "./indexshansong.vue?vue&type=script&lang=js"
export * from "./indexshansong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports